const headerAccountDropdownToggle = document.querySelector('.js-account-dropdown-toggle');
const accountDropdownOptions = document.querySelector('.js-account-menu-lg');

if (headerAccountDropdownToggle != null){
    headerAccountDropdownToggle.addEventListener('click', function() {
        if(accountDropdownOptions.classList.contains('scale-0')){
            accountDropdownOptions.classList.remove('scale-0');
        }
        else {
            accountDropdownOptions.classList.add('scale-0');
        }
    });
}
